module.exports = __webpack_public_path__ + "static/img/7@2x.ef992e74.png";